import React from 'react';
import Card from '../../ui/Card';
const DealerFunnelChart: React.FC = () => {
  const funnelData = [{
    stage: 'Billing to Dealers',
    value: 2960,
    percentage: 100,
    color: 'bg-blue-500',
    description: 'Total billed amount'
  }, {
    stage: 'Dealer Sell-out',
    value: 2664,
    percentage: 90,
    color: 'bg-blue-600',
    description: 'Sold to end customers'
  }, {
    stage: 'Collections Received',
    value: 2516,
    percentage: 85,
    color: 'bg-green-500',
    description: 'Payment collected'
  }];
  const metrics = {
    sellOutRate: 90,
    collectionRate: 85,
    dso: 42,
    outstandingAR: 444
  };
  return <Card className="p-6" data-id="element-7042">
      <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-7043">
        Dealer Funnel Analysis
      </h3>
      <p className="text-sm text-gray-600 mb-4" data-id="element-7044">
        Billing → Sell-out → Collections (₹ Cr)
      </p>
      <div className="space-y-4 py-4" data-id="element-7045">
        {funnelData.map((stage, index) => <div key={index} className="relative" data-id="element-7046">
            <div className="flex items-center justify-between mb-2" data-id="element-7047">
              <div className="flex items-center" data-id="element-7048">
                <span className="text-sm font-medium text-gray-700" data-id="element-7049">
                  {stage.stage}
                </span>
              </div>
              <span className="text-sm font-semibold text-gray-800" data-id="element-7050">
                ₹{stage.value} Cr
              </span>
            </div>
            <div className="relative h-14 bg-gray-100 rounded-lg overflow-hidden" data-id="element-7051">
              <div className={`h-full ${stage.color} flex items-center justify-between px-4 transition-all duration-500`} style={{
            width: `${stage.percentage}%`
          }} data-id="element-7052">
                <span className="text-white font-medium text-sm" data-id="element-7053">
                  {stage.percentage}%
                </span>
                <span className="text-white text-xs" data-id="element-7054">{stage.description}</span>
              </div>
            </div>
            {index < funnelData.length - 1 && <div className="flex items-center justify-center mt-1" data-id="element-7055">
                <span className="text-xs text-gray-500" data-id="element-7056">
                  ↓{' '}
                  {Math.round(funnelData[index + 1].value / stage.value * 100)}
                  % conversion
                </span>
              </div>}
          </div>)}
      </div>
      <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-7057">
        <div className="grid grid-cols-2 gap-4" data-id="element-7058">
          <div data-id="element-7059">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7060">Sell-out Rate</div>
            <div className="text-2xl font-bold text-blue-600" data-id="element-7061">
              {metrics.sellOutRate}%
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-7062">
              Dealers moving inventory
            </div>
          </div>
          <div data-id="element-7063">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7064">Collection Rate</div>
            <div className="text-2xl font-bold text-green-600" data-id="element-7065">
              {metrics.collectionRate}%
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-7066">Payment received</div>
          </div>
          <div data-id="element-7067">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7068">DSO (Days)</div>
            <div className="text-2xl font-bold text-yellow-600" data-id="element-7069">
              {metrics.dso}
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-7070">
              Days sales outstanding
            </div>
          </div>
          <div data-id="element-7071">
            <div className="text-xs text-gray-600 mb-1" data-id="element-7072">Outstanding A/R</div>
            <div className="text-2xl font-bold text-orange-600" data-id="element-7073">
              ₹{metrics.outstandingAR} Cr
            </div>
            <div className="text-xs text-gray-500 mt-1" data-id="element-7074">
              Pending collections
            </div>
          </div>
        </div>
      </div>
    </Card>;
};
export default DealerFunnelChart;